// frontend/src/components/grid/DetailRow.jsx
//
// The root of every master-detail renderer: the band AG Grid draws under an
// open master row. It is AG Grid's own detail-row markup, so the grid's
// `.ag-details-row` stylesheet and the app's rules under MASTER-DETAIL ROW
// STYLING (styles/pages.css) apply whatever the band holds — a sub-grid
// (DetailGrid), a sentence (a failed read, an "all items" promotion).
//
// A `detailCellRenderer` returns this or DetailGrid, never a div of its own;
// detailRow.test.jsx holds the shape.

export default function DetailRow({ children }) {
  return (
    <div className="ag-details-row" role="gridcell">
      {children}
    </div>
  );
}
